"use client";

import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function HablemosDeTuTransformacion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="solicita-tu-presupuesto-de-reparación" className="dark bg-background text-foreground py-20 lg:py-32 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
                <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-chart-2/5 rounded-full blur-3xl" />
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <div ref={ref} className={cn("max-w-3xl mx-auto transition-all duration-1000 ease-out space-y-10", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
                    <div className="space-y-6 text-center lg:text-left">
                        <h1 className="text-4xl md:text-5xl font-default font-bold tracking-tight leading-tight uppercase">
                            Contacto reparación de <span className="text-primary">baterías</span> en Sevilla
                        </h1>
                        <p className="text-lg font-default text-muted-foreground leading-relaxed">
                            Somos el servicio técnico de referencia para la reparación de baterías de litio en Sevilla y toda Andalucía. Desde nuestro taller especializado en Mairena del Aljarafe, en BateríasSevilla garantizamos resultados excepcionales al devolverle la vida a tu patinete o bicicleta eléctrica con total profesionalidad, optimizando cada celda para un rendimiento máximo. Nuestra ubicación estratégica nos permite dar cobertura rápida a todo el Aljarafe.
                        </p>
                        <p className="text-lg font-default text-muted-foreground leading-relaxed">
                            Lideramos el sector trabajando con marcas como Xiaomi, Cecotec, SmartGyro, Kukirin y Dualtron. En nuestras instalaciones de Mairena del Aljarafe realizamos desde diagnósticos avanzados y equilibrados de celdas hasta reconstrucciones integrales de packs y sustitución de BMS para clientes de toda España. Consolidamos nuestra presencia como el centro de confianza en Sevilla para los usuarios del Aljarafe que buscan calidad y garantía.
                        </p>
                    </div>

                    <Card className="border-white/10 bg-card/40 backdrop-blur-xl shadow-2xl overflow-hidden">
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-chart-2 to-primary opacity-80" />
                        <CardHeader>
                            <CardTitle className="text-xl font-default uppercase tracking-wider">Información de Contacto</CardTitle>
                        </CardHeader>
                        <CardContent className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="flex items-center gap-4 group">
                                    <div className="size-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                                        <Phone className="size-6" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-default text-muted-foreground uppercase tracking-widest font-medium">Llámanos</p>
                                        <Link to="tel:+34624990509" className="text-lg font-default font-bold hover:text-primary transition-colors">
                                            624 990 509
                                        </Link>
                                    </div>
                                </div>

                                <div className="flex items-center gap-4 group">
                                    <div className="size-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                                        <Mail className="size-6" />
                                    </div>
                                    <div>
                                        <p className="text-xs font-default text-muted-foreground uppercase tracking-widest font-medium">Escríbenos</p>
                                        <Link to="mailto:reparacionbateriaspatinete@gmail.com" className="text-sm font-default font-bold hover:text-primary transition-colors break-all">
                                            reparacionbateriaspatinete@gmail.com
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <Separator className="bg-white/5" />

                            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                                <div className="flex items-center gap-3">
                                    <MapPin className="size-5 text-primary" />
                                    <p className="text-sm font-default text-foreground font-medium">
                                        Location: Mairena del Aljarafe, Sevilla, España, ubicado en el corazón del Aljarafe
                                    </p>
                                </div>
                                <div className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-4 py-2 text-sm font-default font-bold text-primary animate-pulse">
                                    Diagnóstico desde 20€ sin compromiso
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    <div className="space-y-6">
                        <p className="text-sm font-default text-muted-foreground italic text-center lg:text-left">
                            Ofrecemos servicio de reparación de baterías en Sevilla, con cobertura en toda Andalucía y envíos a toda España. Tu taller de confianza para arreglar baterías de patinetes eléctricos con repuestos de alta calidad y técnicos titulados. Ven a visitarnos a nuestro taller en Mairena del Aljarafe y descubre por qué somos líderes en el sector.
                        </p>
                        
                        <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
                            <Button size="lg" className="h-12 px-8 text-base font-default font-bold shadow-lg shadow-primary/20" asChild>
                                <Link to="https://wa.me/34624990509?text=Hola,%20quiero%20informaci%C3%B3n%20sobre%20la%20reparaci%C3%B3n%20de%20bater%C3%ADas.">
                                    Solicitar diagnóstico
                                </Link>
                            </Button>
                            <Button size="lg" variant="outline" className="h-12 px-8 text-base font-default font-bold border-primary/20 hover:border-primary/40" asChild>
                                <Link to="https://wa.me/34624990509?text=Hola,%20quiero%20informaci%C3%B3n%20sobre%20la%20reparaci%C3%B3n%20de%20bater%C3%ADas.">
                                    Contactar ahora
                                </Link>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
}